<template>
  <section>
    <h1>{{ $t('charge_help.title') }}</h1>
    <div class="Squares">
      <div class="square" @click="onClick(HeaderName.ActivateCharger)">
        <p>{{ $t('charge_help.header_1') }}</p>
        <img src="~@/assets/help/battery-ic.svg" />
      </div>
      <div class="square" @click="onClick(HeaderName.FinishCharging)">
        <p>{{ $t('charge_help.header_2') }}</p>
        <img src="~@/assets/help/charging-ic.svg" />
      </div>
      <div class="square" @click="onClick(HeaderName.Tariff)">
        <p>{{ $t('charge_help.header_3') }}</p>
        <img src="~@/assets/help/euro-ic.svg" />
      </div>
      <div class="square" @click="onClick(HeaderName.Invoice)">
        <p>{{ $t('charge_help.header_4') }}</p>
        <img src="~@/assets/help/invoice-header-ic.svg" />
      </div>
    </div>
    <div class="Header-Footer">
      <p>{{ $t('charge_help.header_question') }}</p>
      <div class="links">
        <router-link :to="{ path: 'faq' }"
          ><span><img src="~@/assets/help/web-ic.svg"/></span
          >{{ $t('charge_help.go_to_faqs') }}</router-link
        >
        <a :href="`tel:${$t('charge_help.header_number')}`"
          ><span><img src="~@/assets/help/phone-ic.svg"/></span
          >{{ $t('charge_help.header_number') }}</a
        >
      </div>
    </div>
  </section>
</template>

<script>
import { HeaderName } from './Info.vue';

export default {
  data() {
    return {
      HeaderName,
    };
  },
  props: ['onClick'],
};
</script>

<style scoped>
section {
  --h-header-color: #2b4047;
  padding: 76px 20px 50px 20px;
  background: #ecf1f2;
}
h1 {
  margin-top: 1em;
  margin-bottom: 1em;
  color: var(--h-header-color);
  text-align: center;
  font-family: 'Foco';
  font-size: 35px;
  line-height: normal;
}
p {
  font-size: 18px;
  color: var(--h-header-color);
  text-align: center;
}
.Squares {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  place-items: center;
  gap: 10px;
  height: 335px;
}
.square {
  background-color: #5e7177;
  max-width: 155px;
  width: 100%;
  height: 100%;
  max-height: 155px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  box-shadow: 5px 4px 4px #0000001a;
}
.square p {
  letter-spacing: 0px;
  color: #ffffff;
  font-size: 17px;
}
.square * {
  grid-area: 1/-1;
}
.Header-Footer {
  margin-top: 4em;
}
.Header-Footer .question {
  width: max-content;
  margin: 0 auto;
  letter-spacing: 0px;
  color: #5e7177;
  font-size: 14px;
}
.Header-Footer .links {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 0;
  place-items: center;
  margin-top: 2em;
}
.links a {
  text-decoration: underline;
  letter-spacing: 0px;
  color: #41565d;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.links a span {
  margin-right: 0.5em;
}
</style>
